// extracted by mini-css-extract-plugin
var _1 = "styles-module__title___PW5uO";
export { _1 as "title" }
